export default "__VITE_ASSET__DX$iKDl5__"